import type {AdminInternalTeam} from "./admin-api";

type TeamTask=AdminInternalTeam["tasks"][number];
const statusLabel=(status:string)=>status==="working"?"Trabajando":
 status==="waiting_approval"?"Esperando aprobación":
 status==="completed"?"Completada":status==="queued"?"En cola":
 status==="blocked"?"Bloqueada":status;

const taskTitle=(task:TeamTask)=>
 typeof task.result.title==="string"?task.result.title:task.command;
const taskSummary=(task:TeamTask)=>
 typeof task.result.summary==="string"?task.result.summary:"Sin resumen persistido.";
const strings=(value:unknown)=>Array.isArray(value)?value.filter((item):item is string=>typeof item==="string"):[];
const reportObject=(task:TeamTask)=>{
 const value=task.result.report;
 return value&&typeof value==="object"?value as Record<string,unknown>:null;
};
const sourceList=(task:TeamTask)=>strings(reportObject(task)?.sources);
const externalActions=(task:TeamTask)=>strings(reportObject(task)?.externalActions);
const executionMode=(task:TeamTask)=>
 typeof reportObject(task)?.executionMode==="string"?String(reportObject(task)!.executionMode):
 task.syntheticOnly?"synthetic":"unknown";

export default function AdminTeamPanel({team}:{team?:AdminInternalTeam}){
 if(!team)return null;
 const recent=team.tasks.slice(0,8);
 return <section className="panel team-panel">
  <div className="panel-title"><div><span className="eyebrow">Equipo MIL</span><h2>Nora, Lía y Álex</h2></div>
   <span className="readonly-chip">Sandbox sintético · FASE 5E</span></div>
  <div className="team-director"><b>MIL Director</b><span>{statusLabel(team.director.status)}</span>
   <small>{team.director.policy}</small></div>
  <div className="team-grid">{team.agents.map(agent=><article className="team-card" key={agent.id}>
   <div className="team-card-head"><div><span className="live-dot"/><b>{agent.name}</b><small>{agent.role}</small></div>
    <span className="status active">{statusLabel(agent.status)}</span></div>
   <p>{agent.currentTask.title}</p><small>{agent.currentTask.summary}</small>
   <ul>{agent.currentTask.outputs.map(item=><li key={item}>{item}</li>)}</ul>
   <footer><span>Autonomía {agent.currentTask.autonomy}</span><span>Cola {agent.queueDepth}</span>
    <span>0 acciones externas</span></footer>
  </article>)}</div>

  <div className="team-persistent-head">
   <div><span className="eyebrow">Cola durable</span><h3>Trabajo persistente</h3></div>
   <span>{recent.length} tareas recientes</span>
  </div>
  <div className="team-task-list">{recent.length===0
   ? <p className="muted">Todavía no hay órdenes persistidas. Las próximas órdenes aparecerán aquí.</p>
   : recent.map(task=><article className="team-task-item" key={task.id}>
      <div className="team-task-summary">
       <span className={"task-state "+task.status}>{statusLabel(task.status)}</span>
       <div><b>{task.target==="lia"?"Lía":task.target==="alex"?"Álex":task.target==="nora"?"Nora":"Director"} · {taskTitle(task)}</b>
        <small>{task.id.slice(0,8)} · {task.origin} · prioridad {task.priority} · intento {task.attemptCount}/{task.maxAttempts} · {new Date(task.createdAt).toLocaleString("es-ES")}</small></div>
       <i>{executionMode(task)==="synthetic"?"SINTÉTICO":"REVISAR"}</i>
      </div>
      <details className="team-task-report">
       <summary>Ver informe completo</summary>
       <div className="team-task-report-grid">
        <section><b>Orden recibida</b><p>{task.command}</p></section>
        <section><b>Resumen</b><p>{taskSummary(task)}</p></section>
        <ReportList title="Resultados" items={strings(task.result.outputs)} empty="Sin resultados persistidos."/>
        <ReportList title="Siguientes acciones" items={strings(task.result.nextActions)} empty="Sin siguientes acciones."/>
        <ReportList title="Fuentes externas" items={sourceList(task)} empty={task.syntheticOnly?"Ninguna. Esta tarea no consultó Internet ni fuentes externas.":"Sin fuentes registradas."}/>
        <ReportList title="Acciones externas" items={externalActions(task)} empty={task.externalActionPerformed?"Acción externa sin detalle: revisar.":"Ninguna acción externa realizada."}/>
        {task.error&&<section className="task-report-error"><b>Error</b><p>{task.error}</p></section>}
       </div>
      </details>
     </article>)}</div>

  <div className="safety-note"><b>Motor W4 verificable; mundo exterior bloqueado</b>
   <p>Una tarea completada significa ejecución del worker sintético, no investigación externa. Fuentes, acciones y modo de ejecución quedan visibles en cada informe.</p></div>
 </section>;
}

function ReportList({title,items,empty}:{title:string;items:string[];empty:string}){
 return <section><b>{title}</b>{items.length
  ? <ul>{items.map((item,index)=><li key={index}>{item}</li>)}</ul>
  : <p className="muted">{empty}</p>}</section>;
}
